
export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/services?${queryString}`);
    return response.data;
  },

  async getById(id) {
    const response = await https.get(`/services/${id}`);
    return response.data.data;
  },

  async add(payload) {
    const response = await https.post(`/services`, payload);
    return response.data;
  },

 
  async update(id, payload) {
    const response = await https.put(`/services/${id}`, payload);
    return response.data;
  },

  async deleteById(id) {
    const response = await https.delete(`/services/${id}`);
    return response.data;
  },
});
